import { TableCell } from '@e2n/ui';
import { Data } from '@/domain/controlling/entities/historie';
import { InterneNotizTooltip } from '@/domain/controlling/pages/Umsatzplanung/components';

export function InterneNotizCell({ tagebuchData }: { tagebuchData: Data }) {
  return tagebuchData.interneNotiz.length > 0 ? (
    <TableCell className="font-medium py-4 ps-4">
      <InterneNotizTooltip interneNotiz={tagebuchData.interneNotiz} />
    </TableCell>
  ) : (
    <TableCell className="font-medium py-4 ps-4" />
  );
}
